import { Route } from 'react-router';
import type { RouteHandle } from '../../shell/AppShell';
import { AfterSalesBoard } from './after-sales/AfterSalesBoard';
import { CasePage } from './after-sales/CasePage';
import { TicketPage } from './detail/TicketPage';
import { MailboxTab } from './mailbox/MailboxTab';
import { TicketsPage } from './TicketsPage';

/**
 * The routes of Tools › Tickets inside the app shell (PLAN §8.3): board and overdue table (Backoffice 03/04), the
 * create dialog, the support mailbox (After-Sales 01/02), the after-sales board and case (03/04), the ticket record
 * (Backoffice 05–08). Static paths come before `/tickets/:id`.
 */
export const ticketsRoutes = (
  <>
    <Route path="/tickets" element={<TicketsPage />} />
    <Route
      path="/tickets/new"
      element={<TicketsPage createOpen />}
      handle={{ mobileTitle: 'Ticket anlegen', mobileBack: '/tickets' } satisfies RouteHandle}
    />
    <Route
      path="/tickets/mailbox"
      element={<MailboxTab />}
      handle={{ mobileTitle: 'Postfach', mobileBack: '/tickets' } satisfies RouteHandle}
    />
    <Route
      path="/tickets/after-sales"
      element={<AfterSalesBoard />}
      handle={{ mobileTitle: 'After-Sales', mobileBack: '/tickets' } satisfies RouteHandle}
    />
    <Route
      path="/tickets/after-sales/:id"
      element={<CasePage />}
      handle={{ mobileTitle: 'After-Sales', mobileBack: '/tickets/after-sales' } satisfies RouteHandle}
    />
    <Route
      path="/tickets/:id"
      element={<TicketPage />}
      handle={{ mobileTitle: 'Ticket', mobileBack: '/tickets' } satisfies RouteHandle}
    />
  </>
);
